import React, { useMemo } from "react";
import { Star } from "lucide-react";
import { useIntl } from "react-intl";
import { INDICATOR_DEFINITIONS } from "../../../engine/indicators/registry";
import "./IndicatorCatalog.sass";

const STAR_ICON_SIZE = 14;

/**
 * The All tab: the 32 indicators in the order of the PO menu; the Favorites
 * tab: only the starred ones, in the same order. A click on a name adds the
 * indicator with the PO inputs.
 *
 * @param {object}   props
 * @param {string[]} props.favoriteIds - registry ids
 * @param {boolean}  [props.isFavoritesOnly]
 * @param {(id: string) => void} props.onAdd
 * @param {(id: string) => void} props.onToggleFavorite
 */
const IndicatorCatalog = ({ favoriteIds, isFavoritesOnly = false, onAdd, onToggleFavorite }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const definitions = useMemo(
    () =>
      isFavoritesOnly
        ? INDICATOR_DEFINITIONS.filter(({ id }) => favoriteIds.includes(id))
        : INDICATOR_DEFINITIONS,
    [favoriteIds, isFavoritesOnly],
  );

  return (
    <ul className="indicator-catalog">
      {definitions.map(({ id, name }) => {
        const isFavorite = favoriteIds.includes(id);

        return (
          <li key={id} className="indicator-catalog__item">
            <button
              type="button"
              className={`indicator-catalog__star${isFavorite ? " indicator-catalog__star--active" : ""}`}
              aria-label={t(
                isFavorite
                  ? "futures.chart.indicators.remove_favorite"
                  : "futures.chart.indicators.add_favorite",
              )}
              aria-pressed={isFavorite}
              onClick={() => onToggleFavorite(id)}
            >
              <Star size={STAR_ICON_SIZE} fill={isFavorite ? "currentColor" : "none"} aria-hidden="true" />
            </button>
            <button type="button" className="indicator-catalog__name" onClick={() => onAdd(id)}>
              {name}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default IndicatorCatalog;
